import { DELIVERY_COCKPIT_DEFERRED_SEARCH_PATHS } from './deliveryCockpitNav';

/** Legacy aliases and analytics paths that must not leak in the public edition. */
export const DEFERRED_ROUTE_EXTRA_PATHS = [
    '/advanced-analytics',
    '/ml-dashboard',
    '/financial-dashboard',
    '/cost-dashboard',
    '/cost-dashboard-legacy',
    '/api-test',
    '/resource-hub-test',
    '/accessibility-demo',
];

const ANALYTICS_DEFERRED_PREFIX = '/analytics/';

/**
 * Normalize a pathname for deferred-route checks (strip query string).
 *
 * @param {string|null|undefined} pathname - Location pathname.
 * @returns {string}
 */
export const normalizeRoutePath = (pathname) => (
    (pathname || '').split('?')[0] || ''
);

/**
 * True when the path is a deferred / enterprise route (nav-hidden module).
 *
 * @param {string|null|undefined} pathname - Location pathname.
 * @returns {boolean}
 */
export const isDeferredRoutePath = (pathname) => {
    const path = normalizeRoutePath(pathname);
    if (!path) {
        return false;
    }
    if (DELIVERY_COCKPIT_DEFERRED_SEARCH_PATHS.has(path)) {
        return true;
    }
    if (DEFERRED_ROUTE_EXTRA_PATHS.includes(path)) {
        return true;
    }
    if (path.startsWith(ANALYTICS_DEFERRED_PREFIX)) {
        return true;
    }
    if (path.startsWith('/document-control')) {
        return true;
    }
    if (path.startsWith('/gantt-chart')) {
        return true;
    }
    if (path.startsWith('/reports')) {
        return true;
    }
    return false;
};
